module.exports = __webpack_public_path__ + "img/icon1.070027d7.png";